/* Wicker vs. Aluminum guide – newsletter form hydration + inline thank-you message */
(function () {
  var tpl = document.getElementById('aw-form-tpl');
  if (!tpl) return;
  document.querySelectorAll('[data-aw-form-slot]').forEach(function (slot) {
    var frag = tpl.content.cloneNode(true);
    var form = frag.querySelector('form.aw-form');
    var title = slot.getAttribute('data-title');
    var intro = slot.getAttribute('data-intro');
    var btn = slot.getAttribute('data-button');
    var thanks = slot.getAttribute('data-thanks');
    if (btn) { var b = form.querySelector('button.aw-btn'); if (b) b.textContent = btn; }
    if (thanks) { var t = form.querySelector('.aw-thanks'); if (t) t.textContent = thanks; }
    if (intro) {
      var p = document.createElement('p');
      p.className = 'aw-fp';
      p.textContent = intro;
      form.insertBefore(p, form.firstChild);
    }
    if (title) {
      var h = document.createElement('h2');
      h.className = 'aw-fh';
      h.textContent = title;
      form.insertBefore(h, form.firstChild);
    }
    slot.replaceWith(frag);
  });
  document.querySelectorAll('form.aw-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      form.classList.remove('has-err');
      fetch(form.getAttribute('action') || '/contact#contact_form', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' }
      }).then(function (r) {
        if (r.url && r.url.indexOf('/challenge') > -1) { form.submit(); return; }
        if (r.ok) { form.classList.add('is-done'); } else { form.classList.add('has-err'); }
      }).catch(function () { form.classList.add('has-err'); });
    });
  });
})();
